import { FC, ReactNode, useCallback, useRef, useState } from 'react';

import { ExpandIcon } from 'components/UI/ExpandIcon';

import { Container, Content, ContentContainer, SectionButton } from './styled';

type Props = {
  children: ReactNode;
  title: string;
  openByDefault?: boolean;
  isLast?: boolean;
};

const ExpandableSection: FC<Props> = ({
  children,
  title,
  openByDefault = false,
  isLast = false
}) => {
  // State
  const [isOpen, setIsOpen] = useState<boolean>(openByDefault);

  // Actions
  const toggleOpen = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  // Refs
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <Container $isLast={isLast}>
      <SectionButton onClick={toggleOpen} $isOpen={isOpen}>
        {title}
        <ExpandIcon isOpen={isOpen} />
      </SectionButton>
      <ContentContainer
        initial={false}
        animate={isOpen ? 'open' : 'closed'}
        transition={{ ease: 'easeOut' }}
        variants={{
          open: {
            height: 'auto',
            opacity: 1,
            transition: {
              duration: 0.2
            }
          },
          closed: {
            height: 0,
            opacity: 0,
            transition: {
              duration: 0.2
            }
          }
        }}
      >
        <Content ref={contentRef}>{children}</Content>
      </ContentContainer>
    </Container>
  );
};

export default ExpandableSection;
